import classNames from 'classnames';
import { useViewEvent } from '@stitch-fix/event-reporter';
import { useInView } from 'react-intersection-observer';
import { CloudinaryImageWrapper, type CloudinaryImageWrapperProps } from '../../../../components/CloudinaryImageWrapper';
import styles from './style.module.scss';
export interface DynamicAdsImageProps {
  image: Pick<CloudinaryImageWrapperProps, 'src' | 'alt'>;
  aspectRatio: CloudinaryImageWrapperProps['sources'];
  index: number;
}
export const DynamicAdsImage = ({
  image,
  aspectRatio,
  index
}: DynamicAdsImageProps) => {
  const [inViewRef, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  });
  const {
    ref: viewRef,
    EventProvider
  } = useViewEvent({
    schema: 'view',
    name: 'dynamic_ads_carousel',
    order: {
      index
    }
  });
  return <EventProvider>
      <div className={styles.imageContainer} ref={viewRef}>
        <div data-testid="gallery-image" className={classNames(styles.image, {
        [styles.inView]: inView
      })} ref={inViewRef}>
          <CloudinaryImageWrapper alt={image.alt} src={image.src} sources={aspectRatio} lazy convertToCloudFront={false} transforms={{
          ar: '1',
          e: ['replace_color:f2f3f4:300:ffffff']
        }} />
        </div>
      </div>
    </EventProvider>;
};